import React from "react";
import './OrderDraftColumn.css'
import { formatDate, formatPrice } from "../utils";
import { ModalCustomer } from "./ModalCustomer.tsx";
import { Customer, Order } from "depoto-core";
import { VatAllocationsTable } from "./VatAllocationsTable.tsx";
import {useCore} from "../hooks";
import {useNavigate} from "react-router";

type Props = {
  order: Order
  isReservation: boolean
  showCustomerHeader?: boolean
  onExistingOrderCustomerChange?: (c: Customer | null) => void
}
export const OrderFinalSummary: React.FC<Props> = ({ order, isReservation, showCustomerHeader = true, onExistingOrderCustomerChange }) => {
  const { currency } = useCore()
  const navigate = useNavigate()

  const openRelatedOrder = () => {
    navigate(`/checkout-detail/order/${order.relatedParent.id}`)
  }
  // const isReservation = order.status?.id === 'reservation'
  // todo percentual sales!!!!!!!!!!!!!!!! uaaaaa
  return (
    <div className="w-full scrollable-y bg-white rounded-md p-4 shadow-sm">
      {showCustomerHeader ? (
        <div className="flex flex-row justify-between">
          <div className="font-semibold text-lg">
            {isReservation ? (
              <div>Rezervace</div>
            ) : (
              <div>Objednávka</div>
            )}
          </div>
          <ModalCustomer />
        </div>
      ) : null}
      <div className="py-4 border-b border-base-200 my-4">
        <div className="flex flex-row justify-between">
          <div className="font-bold">Číslo {isReservation ? 'rezervace' : 'objednávky'}</div>
          <div className="font-medium">{(isReservation ? order.reservationNumber : order.billNumber) || ''}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="font-bold">Datum vystavení</div>
          <div className="font-medium">{order.dateCreated?.length ? formatDate(new Date(order.dateCreated), false, true) : ''}</div>
        </div>
        {!isReservation && (
          <div className="flex flex-row justify-between">
            <div className="font-bold">DUZP</div>
            <div className="font-medium">{order.dateDue?.length ? formatDate(new Date(order.dateDue), false) : ''}</div>
          </div>
        )}
        {(order?.customer || onExistingOrderCustomerChange) && (
          <div className="flex flex-row justify-between items-center">
            <div className="font-bold">Zákazník</div>
            <div className="flex flex-row items-center gap-2">
              {onExistingOrderCustomerChange ? (
                <ModalCustomer onExistingOrderCustomerChange={onExistingOrderCustomerChange} customer={order.customer} />
              ) : (
                <div className="font-medium">
                  {order.customer ? `${order.customer.firstName || ''} ${order.customer.lastName || ''}`.trim() : ''}
                </div>
              )}
            </div>
          </div>
        )}
        {order?.relatedParent?.id > 0 && (
          <div className="flex flex-row justify-between">
            <div className="font-bold">Připojená objednávka</div>
            <div className="font-medium cursor-pointer" onClick={openRelatedOrder}>{order.relatedParent.billNumber || order.relatedParent.reservationNumber}</div>
          </div>
        )}
      </div>

      <div className="flex flex-row justify-between"></div>
      <table className="w-full text-left table table-sm font-medium">
        <thead>
          <tr className="font-bold text-black">
            <th>Počet</th>
            <th>Položka</th>
            <th className="w-30">Cena</th>
            <th className="w-30">Daň</th>
            <th className="w-30 text-right">Celkem</th>
          </tr>
        </thead>
        <tbody>
          {order.items.map(oi => (
            <tr key={`order-item-${oi.uuid ? oi.uuid : oi.id}`}>
              <td>{oi.quantity}</td>
              <td>{oi.name}</td>
              <td>{formatPrice(oi.priceAllWithoutVat, currency?.id)}</td>
              <td>{oi.vat.percent}%</td>
              <td className="text-right">{formatPrice(oi.priceAll, currency?.id)}</td>
            </tr>
          ))}
        </tbody>

      </table>
      <div className=" w-full border-t border-base-200 mt-2 pt-2">
        <div className="ml-auto 2xl:max-w-7/12 font-medium">
          <VatAllocationsTable vatAllocations={order.vatAllocations} currency={currency} />
        </div>
      </div>
      <div className=" w-full border-t border-base-200 mt-2 pt-2">
        <div className="ml-auto max-w-7/12 font-medium">
          <table className="w-full table-sm text-left">
            <thead className="font-bold text-black">
              <tr>
                <th className="w-30" colSpan={1}>Platba</th>
                <th className="w-30 text-right" colSpan={1}>Částka</th>
              </tr>
            </thead>
            <tbody>
              {order.paymentItems?.length ? order.paymentItems.map((pi, i) => (
                <tr key={`payment-${pi.id}-${i}`}>
                  <td className="w-30" colSpan={1}>
                    {pi?.payment?.name}
                  </td>
                  <td className="w-30 text-right">
                    {formatPrice(pi.amount, currency?.id)}
                  </td>
                </tr>
              )) : null}
            </tbody>
          </table>
        </div>
      </div>
      <table className="border-t border-base-200 w-full text-left table ">
        <thead className="font-bold text-black">
          <tr>
            <td colSpan={3}>Zaokrouhlení</td>
            <td colSpan={1} className="text-right">{formatPrice(order.rounding, currency?.id)}</td>
          </tr>
          <tr>
            <th colSpan={3}>Celkem s DPH</th>
            <th colSpan={1} className="text-right">{formatPrice(order.priceAll, currency?.id)}</th>
          </tr>
        </thead>
      </table>
      {order?.note?.length || order?.privateNote?.length ? (
        <div className="flex flex-col justify-between mt-5">
          {order?.note?.length > 0 && (
              <div className="flex flex-col justify-between">
                <div className="font-bold w-100">Poznámka</div>
                <div className="font-medium">{order.note}</div>
              </div>
            )}
            {order?.privateNote?.length > 0 && (
              <div className="flex flex-col justify-between mt-3">
                <div className="font-bold w-100">Interní poznámka</div>
                <div className="font-medium text-error">{order.privateNote}</div>
              </div>
            )}
        </div>
      ) : null}
    </div>
  )
}
